export const PLAN_TYPES = {
  FREE: 'FREE',
  PRO: 'PRO',
  PREMIUM: 'PREMIUM',
  ITR_FILING_PRO: 'ITR FILING PRO',
  ITR_FILING_PREMIUM: 'ITR FILING PREMIUM',
  CUSTOM: 'CUSTOM'
};
